export default __webpack_public_path__ + "static/media/attention_1.7435aedd.svg";